import {getPageServiceApiUrl} from 'features/services/utils/env-helper';

export const PAGESERVICE_API_URL = getPageServiceApiUrl();
